export const Marquee = ({ categories, locations }) => {
  const items = [
    ...categories.map((c) => c.name),
    ...locations.map((l) => `${l.city}, AL`),
  ];
  if (items.length === 0) return null;
  const row = [...items, ...items];

  return (
    <div data-testid="editorial-marquee" className="bg-[#F4F5F7] border-y border-border py-5 overflow-hidden">
      <div className="marquee-track items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-heading font-bold text-navy uppercase tracking-[0.15em] text-sm px-6 whitespace-nowrap">
              {item}
            </span>
            <span className="text-flame text-lg">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
